import { cn } from '@/utils/cn';
import { ErrorMessage, Field } from 'formik';
import { forwardRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface PasswordInputProps {
  label?: string;
  name?: string;
  error?: boolean;
  placeholder?: string;
  containerStyle?: string;
  labelStyle?: string;
  inputStyle?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    {
      label,
      name,
      error,
      containerStyle = '',
      placeholder,
      labelStyle = '',
      inputStyle = '',
    },
    ref,
  ) => {
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const togglePasswordVisibility = () => {
      setPasswordVisible(!isPasswordVisible);
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 200);
    };
    return (
      <div className={cn('relative flex flex-col space-y-2', containerStyle)}>
        {label && (
          <label
            className={cn(`text-xs font-medium text-gray-600`, labelStyle)}
          >
            {label}
          </label>
        )}

        <div className="relative">
          <Field
            type={isPasswordVisible ? 'text' : 'password'}
            ref={ref}
            name={name}
            placeholder={placeholder}
            className={cn(
              `w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 shadow-sm transition-colors focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-200`,
              error
                ? 'border-red-500 focus:border-red-500 focus:ring-red-200'
                : '',
              inputStyle,
            )}
          />
          <span
            onClick={togglePasswordVisibility}
            className={cn(
              `absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer transition duration-200 ease-in-out`,
              isAnimating && 'scale-125',
            )}
          >
            {isPasswordVisible ? (
              <FaEye className="text-gray-500 hover:text-sky-600" />
            ) : (
              <FaEyeSlash className="text-gray-500 hover:text-sky-600" />
            )}
          </span>
        </div>
        <ErrorMessage
          name={name as string}
          component="span"
          className="text-sm text-danger"
        />
      </div>
    );
  },
);
